<template>
  <v-scale-transition>
    <v-btn
      id="btn-whatsapp"
      fab
      dark
      fixed
      right
      bottom
      color="success"
      href="https://wa.me/5491131008698"
      target="_blank"
    >
      <v-icon>mdi-whatsapp</v-icon>
    </v-btn>
  </v-scale-transition>
</template>

<script>
export default {
  name: "BtnWhatsapp"
};
</script>

<style scoped>
/* #btn-whatsapp {
    bottom: 80px;
  } */
</style>
